import { ChecklistStore, ActionStore } from "@cmodules/checklist/assets/data/types"
import { cases } from './actions'

const initialState: ChecklistStore = new ChecklistStore()

export const checkListReducer = (state: ChecklistStore = initialState, action: ActionStore): ChecklistStore => {
  const handler = cases[action.type]
  if (handler) {
    return handler(state, action)
  }
  return state
}
